import { useUserInfoQuery } from '~/apis/auth';
import { useReleaseNotePopupQuery } from '~/apis/releaseNote';
import { ReleaseReleaseNoteProtocolsGetPopupResponse } from '~/swagger/data-contracts';

export const useViewModel = (enabled: boolean) => {
  const { data: userInfo } = useUserInfoQuery();
  const { data } = useReleaseNotePopupQuery({ select: parseDate, enabled });

  const exploreLabel = userInfo?.language === 'en-US' ? 'Explore' : '둘러보기';
  const isPopupVisible = (enabled && data?.popup) || !enabled;

  return {
    isPopupVisible,
    popupProps: data?.popup && {
      title: data.popup.title,
      content: data.popup.content,
      image: data.popup.imageUrl ? { url: data.popup.imageUrl } : undefined,
      actionLabel: exploreLabel,
    },
  };
};

const parseDate = (data: ReleaseReleaseNoteProtocolsGetPopupResponse) => {
  const popup =
    data.popup?.title && data.popup.content
      ? {
          title: data.popup.title,
          content: data.popup.content,
          imageUrl: data.popup.thumbnail_url || undefined,
        }
      : undefined;

  return {
    popup,
  };
};
